import { render, staticRenderFns } from "./DynamicTemplate.vue?vue&type=template&id=3688e11e&scoped=true"
import script from "./DynamicTemplate.vue?vue&type=script&lang=js"
export * from "./DynamicTemplate.vue?vue&type=script&lang=js"
import style0 from "./DynamicTemplate.vue?vue&type=style&index=0&id=3688e11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3688e11e",
  null
  
)

export default component.exports